import React from 'react';
import { Link } from 'react-router-dom';
import { ReactComponent as ChevronRightIcon } from 'theme/svg/chevron-right.svg';

import styles from './Breadcrumbs.module.scss';

type Ancestor = {
  title: string;
  to: string;
};

export type BreadcrumbsProps = {
  ancestors: Ancestor[];
  current: string;
};

const Breadcrumbs = ({ ancestors, current }: BreadcrumbsProps): JSX.Element => {
  return (
    <header className={styles.breadcrumbs}>
      <div className={styles.container}>
        {ancestors.map((a, i) => (
          <div key={i}>
            <Link to={a.to} className={styles.ancestor}>
              {a.title}
            </Link>
            <ChevronRightIcon />
          </div>
        ))}
      </div>
      <div className={styles.current}>{current}</div>
    </header>
  );
};

export default Breadcrumbs;
